module.exports = __webpack_public_path__ + "static/media/IMG_4215.574bb172.JPG";